import {LogFilter} from '../types/log-filter';

export abstract class LogForm {
  static initFilters(filters: any = {}): LogFilter {
    filters['id'] = null;
    filters['date'] = null;
    filters['productId'] = null;
    filters['offerId'] = null;
    filters['accountType'] = null;
    filters['partnerId'] = null;
    filters['lang'] = null;
    filters['country'] = null;
    filters['subid'] = '';
    filters['tc1'] = '';
    filters['tc2'] = '';
    filters['tc3'] = '';
    filters['tc4'] = '';
    filters['landingPageId'] = null;
    filters['landingPageActiveSince'] = null;

    return filters;
  }

  static getFilters(filters: LogFilter, groups: string|null): any {
    const params: any = {};

    if (groups !== null) {
      params.groups = groups;
    }

    if (filters.id) {
      params.id = filters.id;
    }

    if (filters.date.start) {
      params.startDate = filters.date.start.toISOString();
    }

    if (filters.date.end) {
      params.endDate = filters.date.end.toISOString();
    }

    if (filters.productId) {
      params.productId = filters.productId;
    }

    if (filters.offerId) {
      params.offerId = filters.offerId;
    }

    if (filters.accountType) {
      params.accountType = filters.accountType;
    }

    if (filters.partnerId) {
      params.partnerId = filters.partnerId;
    }

    if (filters.lang) {
      params.lang = filters.lang;
    }

    if (filters.country) {
      params.country = filters.country;
    }

    if (filters.subid) {
      params.subid = filters.subid;
    }

    if (filters.tc1) {
      params.tc1 = filters.tc1;
    }

    if (filters.tc2) {
      params.tc2 = filters.tc2;
    }

    if (filters.tc3) {
      params.tc3 = filters.tc3;
    }

    if (filters.tc4) {
      params.tc4 = filters.tc4;
    }

    if (filters.landingPageId) {
      params.landingPageId = filters.landingPageId;
    }

    if (filters.landingPageActiveSince) {
      params.landingPageActiveSince = filters.landingPageActiveSince;
    }

    return params;
  }
}
